import { Check, Minus } from "lucide-react";
import { COMPARISON } from "@/marketing/data";
import { useI18n } from "@/i18n/I18nContext";

function Cell({ value, elite }) {
  if (value === true)
    return <Check size={18} strokeWidth={2.4} className={elite ? "text-[#D4AF37] mx-auto" : "text-[#2C3E35] mx-auto"} />;
  if (value === false)
    return <Minus size={16} className="text-[#2C3E35]/25 mx-auto" />;
  return <span className={`text-sm font-medium ${elite ? "text-[#D4AF37]" : "text-[#2C3E35]"}`}>{value}</span>;
}

export default function ComparisonTable() {
  const { t, lang } = useI18n();
  const rows = COMPARISON[lang] || COMPARISON.en;
  return (
    <div data-testid="comparison-table" className="rounded-2xl border border-[#2C3E35]/10 bg-white overflow-hidden shadow-[0_8px_32px_rgba(44,62,53,0.06)]">
      <div className="grid grid-cols-[1.4fr_1fr_1fr] bg-[#F5F2ED] border-b border-[#2C3E35]/10">
        <div className="p-5 font-display font-bold text-[#0A0A0A]">{t.pricing.featuresTitle}</div>
        <div className="p-5 text-center font-display font-bold text-[#2C3E35]">{t.pricing.colBasic}</div>
        <div className="p-5 text-center font-display font-bold text-[#2C3E35] bg-[#2C3E35]/5 relative">
          <span className="inline-flex items-center gap-1.5">{t.pricing.colElite} <span className="text-[10px] px-2 py-0.5 rounded-full bg-[#D4AF37] text-[#2C3E35] uppercase tracking-wide">{t.pricing.mostPopular}</span></span>
        </div>
      </div>
      {rows.map((row, i) => (
        <div key={row.category} className={`grid grid-cols-[1.4fr_1fr_1fr] items-center ${i % 2 ? "bg-[#FDFBF9]" : "bg-white"} border-b border-[#2C3E35]/6 last:border-0`}>
          <div className="p-4 text-sm font-medium text-[#0A0A0A]">{row.category}</div>
          <div className="p-4 text-center"><Cell value={row.basic} /></div>
          <div className="p-4 text-center bg-[#2C3E35]/[0.03]"><Cell value={row.elite} elite /></div>
        </div>
      ))}
    </div>
  );
}
